import { render } from "./ThemeModal.vue?vue&type=template&id=c653a2fe"
import script from "./ThemeModal.vue?vue&type=script&lang=js"
export * from "./ThemeModal.vue?vue&type=script&lang=js"

import "./ThemeModal.vue?vue&type=style&index=0&id=c653a2fe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__